import { render, staticRenderFns } from "./TheMenuItem.vue?vue&type=template&id=043d4156&scoped=true&"
import script from "./TheMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TheMenuItem.vue?vue&type=style&index=0&id=043d4156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043d4156",
  null
  
)

export default component.exports